import ScrollProgressEnum from '@models/enums/ScrollProgressEnum';
import { useMotionValueEvent, useScroll } from 'framer-motion';
import { RefObject, useEffect, useState } from 'react';

const useVerticalScrollShadows = (
  containerRef: RefObject<HTMLElement>,
  containerHeight: number,
  contentHeight: number,
  disabled = false
) => {
  const { scrollYProgress } = useScroll({
    container: containerRef,
  });
  const [isStart, setIsStart] = useState(true);
  const [isEnd, setIsEnd] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(
    ScrollProgressEnum.Start
  );
  const threshold = 0.05;

  useMotionValueEvent(scrollYProgress, 'change', (value: number) => {
    if (value < threshold) {
      setScrollProgress(ScrollProgressEnum.Start);
    }

    if (value >= threshold && value <= 1 - threshold) {
      setScrollProgress(ScrollProgressEnum.Middle);
    }

    if (value > 1 - threshold) {
      setScrollProgress(ScrollProgressEnum.End);
    }
  });

  useEffect(() => {
    if (!containerHeight || disabled) return;

    if (containerHeight >= contentHeight) {
      setIsStart(true);
      setIsEnd(true);

      return;
    }

    if (scrollProgress === ScrollProgressEnum.Start) {
      setIsStart(true);
      setIsEnd(false);
    }

    if (scrollProgress === ScrollProgressEnum.Middle) {
      setIsStart(false);
      setIsEnd(false);
    }

    if (scrollProgress === ScrollProgressEnum.End) {
      setIsEnd(true);
    }
  }, [disabled, scrollProgress, containerHeight, contentHeight]);

  return { isStart, isEnd };
};

export default useVerticalScrollShadows;
